import { API_ENDPOINT } from 'helper';

export const syncDevice = async (device, accessToken) => {
    const payload = {
        serial_number: device.SerialNumber,
        pack_mapping: extractPackMapping(device),
        synchDevice: 'true', // set Thing record to have isSynched = true
    };
    const Thing_ID = device.Thing_ID;
    try {
        const syncResponse = await fetch(
            `${API_ENDPOINT}/devices/${Thing_ID}/sync`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: accessToken,
                },
                body: JSON.stringify(payload),
            }
        );
        const data = await syncResponse.json();
        if (!syncResponse.ok) {
            throw new Error(
                data.message || data.error || 'Failed to sync device.'
            );
        }
        return data;
    } catch (error) {
        console.error('Error syncing device:', error.message);
        throw error;
    }
};

/**
 * Extracts the pack_mapping from the given unmarshalled thing object.
 *
 * @param {Object} thingObject - The unmarshalled thing object containing device configurations.
 * @returns {Object} packMapping - A dictionary mapping uppercase pack identifiers (e.g., 'P1') to PACK_SN.
 */
const extractPackMapping = (thingObject) => {
    const packMapping = {};

    try {
        const masterSnsArray = thingObject.Config?.data?.MASTER_SNS;

        if (!Array.isArray(masterSnsArray) || masterSnsArray.length === 0) {
            console.warn('MASTER_SNS array is empty or not found.');
            return packMapping;
        }

        const masterSns = masterSnsArray[0];
        const packs = masterSns.PACKS;

        if (!Array.isArray(packs) || packs.length === 0) {
            console.warn('PACKS array is empty or not found.');
            return packMapping;
        }

        // Extract Names mapping: PACK_SN -> pack identifier (e.g., 'p1')
        const namesMapping = thingObject.Names || {};
        const packSnToId = {};

        for (const [packSn, packId] of Object.entries(namesMapping)) {
            if (typeof packId === 'string') {
                packSnToId[packSn] = packId.toUpperCase();
            }
        }

        packs.forEach((pack) => {
            const packSn = pack.PACK_SN;
            const packId = packSnToId[packSn];

            if (packId) {
                packMapping[packId] = packSn;
            } else {
                console.warn(`PACK_SN ${packSn} not found in Names mapping.`);
            }
        });
    } catch (error) {
        console.error('Error extracting pack_mapping:', error);
    }

    return packMapping;
};
